var chunkMapping = {
	"255": [
		10255
	],
	"1747": [
		31747
	],
	"1983": [
		31983
	],
	"2010": [
		12010
	],
	"2057": [
		32057
	],
	"2500": [
		22500
	],
	"2596": [
		92596
	],
	"6851": [
		76851
	],
	"8319": [
		78319
	]
};
var idToExternalAndNameMapping = {
	"10255": [
		"default",
		"./Module",
		74836
	],
	"12010": [
		"default",
		"./Module",
		78240
	],
	"22500": [
		"default",
		"./Module",
		25492
	],
	"31747": [
		"default",
		"./Module",
		35778
	],
	"31983": [
		"default",
		"./Module",
		59583
	],
	"32057": [
		"default",
		"./Module",
		70315
	],
	"76851": [
		"default",
		"./Module",
		77398
	],
	"78319": [
		"default",
		"./Module",
		61160
	],
	"92596": [
		"default",
		"./Module",
		84113
	]
};
var idToRemoteMap = {
	"10255": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 74836
		}
	],
	"12010": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 78240
		}
	],
	"22500": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 25492
		}
	],
	"31747": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 35778
		}
	],
	"31983": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 59583
		}
	],
	"32057": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 70315
		}
	],
	"76851": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 77398
		}
	],
	"78319": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 61160
		}
	],
	"92596": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 84113
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}